import Vue from "vue/dist/vue.esm.js";
import _ from "lodash";
import * as MoneyUtil from "@/helper/util/Money"
import {DateTime} from "luxon";
import {stripTags} from "@/helper/String";
import {getMonthName} from "@/helper/Date";

Vue.filter('optionText', (value, options) =>
{
	const item = _.find(options, option => option.value === value);

	return item ? item.text : null;
});

Vue.filter('join', (value, delimiter) =>
{
	return value.join(delimiter);
});

Vue.filter('phone', (value) =>
{
	return '+' + value.countryCode + ' ' + value.number;
});

Vue.filter('date', (value, format) =>
{
	const date = getDate(value);

	return date.toFormat(format || 'dd.LL.y');
});

Vue.filter('fullDate', (value) =>
{
	const date = getDate(value);

	return date.toFormat('dd. LLLL y');
});

Vue.filter('dateTime', (value) =>
{
	const date = getDate(value);

	return date.toFormat('dd.LL.y HH:mm');
});

Vue.filter('dateByObject', (value, format) =>
{
	const date = DateTime.fromObject(value);

	return date.toFormat(format || 'dd.LL.y');
});

Vue.filter('timeByObject', (value) =>
{
	const date = DateTime.fromObject(value);

	return date.toFormat('HH:mm');
});

Vue.filter('monthYearByObject', (value) =>
{
	return getMonthName(value.month) + ' ' + value.year;
});

Vue.filter('fullDateTime', (value) =>
{
	const date = getDate(value);

	return date.toFormat('dd. LLLL y, HH:mm') + ' Uhr';
});

Vue.filter('fullDateTimeByDateAndTime', (value) =>
{
	return DateTime
		.fromObject({
			year: value.date.year,
			month: value.date.month,
			day: value.date.day,
			hour: value.time.hour,
			minute: value.time.minute
		})
		.toFormat('dd. LLLL y HH:mm') + ' Uhr';
});

Vue.filter('weekdayShort', (value) =>
{
	const date = getDate(value);

	return date.weekdayShort;
});

Vue.filter('moneyAmount', (amount) =>
{
	return MoneyUtil.format(amount);
});

Vue.filter('stripTags', (text) =>
{
	return stripTags(text);
});

function getDate (value)
{
	if (typeof value === 'object' && value.isLuxonDateTime)
	{
		return value;
	}

	return typeof value === 'string'
		? DateTime.fromISO(value)
		: (typeof value === 'object' ? DateTime.fromJSDate(value) : value);
}
